@if (dataContext) {
  <form class="deliver-invoice-reminder-form astral-stack-m" [formGroup]="form" (ngSubmit)="onSubmit()">
    @if (invoice) {
      <section class="astral-section-surface astral-section-surface--compact astral-stack-m">
        <h4>{{ 'INVOICE.SEND_INVOICE_REMINDER' | translate }}</h4>
        <div>{{ 'INVOICE.INVOICE_NUMBER' | translate }}: {{ invoice.invoiceNumber }}</div>
        <astral-select [control]="form.controls['deliveryMethod']" [itemsSource]="deliveryMethods"></astral-select>
        @if (isDeliveryMethodEmail) {
          <astral-input
            [control]="form.controls['invoiceRecipientEmail']"
            [helpText]="'INVOICE.HELP_TEXT.EMAIL'"
          ></astral-input>
        }
        @if (isDeliveryMethodMail) {
          <app-information-block
            [text]="('INVOICE.DELIVERY_ADDRESS' | translate) + ': ' + mailDeliveryAddress"
          ></app-information-block>
        }
        <astral-checkbox [control]="form.controls['sendToGuarantor']"></astral-checkbox>
      </section>
    }
    <div class="astral-form-actions">
      <astral-button variant="primary" type="submit" [disabled]="form.disabled" label="OK"></astral-button>
      <astral-button variant="secondary" type="button" [disabled]="form.disabled" labelKey="CANCEL_BTN" (click)="cancel()"></astral-button>
    </div>
  </form>
}
